import type { IScheduledPdfCustomReport } from '@/Interfaces/PdfBuilder/ScheduledPdfCustomReport.interface';
import { dateToShortFormat } from '@/helpers/valueFormatter/dateFormatter.helpers';
import EmailsCell from '@/pages/ReportBuilder/ScheduledReportsGrid/EmailsCell';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import ActionsCell from './ActionsCell';

interface IColumnsParams {
  onEdit: (report: IScheduledPdfCustomReport) => void;
  onCancel: (id: number) => void;
}

/**
 + * Factory for scheduled reports grid column definitions.
 + * Accepts callbacks to wire row-level actions (edit, cancel) into column renderers.
 + */
export const getColumns = ({ onEdit, onCancel }: IColumnsParams): GridColDef[] => [
  {
    field: 'name',
    flex: 2,
    headerName: 'Report Name',
  },
  {
    field: 'interval',
    flex: 1,
    headerName: 'Interval',
  },
  {
    field: 'pdfCustomReports',
    flex: 1,
    headerName: 'Last Date Sent',
    sortable: false,
    valueFormatter: (value: IScheduledPdfCustomReport['pdfCustomReports']) => dateToShortFormat(value?.[0]?.updatedAt),
  },
  {
    field: 'recipientEmails',
    flex: 3.5,
    headerName: 'Recipient Emails',
    sortable: false,
    display: 'flex',
    renderCell: EmailsCell,
  },
  {
    field: 'id',
    flex: 1,
    headerName: 'Actions',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    display: 'flex',
    renderCell: (params: GridRenderCellParams<IScheduledPdfCustomReport>) => (
      <ActionsCell {...params} onEdit={onEdit} onCancel={onCancel} />
    ),
  },
];
